import {UserModel} from '../../shared/services/user/user.model';
import {UserPasswordModel} from '../../shared/services/user/user.password.model';

export class UserRestore {
  static readonly type = '[account] restore user';
  constructor() {}
}

export class UserLogin {
  static readonly type = '[account] login user';
  constructor(public basicAuth: string) {}
}

export class UserLogout {
  static readonly type = '[account] logout';
}

export class UpdateCurrentUser {
  static readonly type = '[account] update user';
  constructor(public user: UserModel) {}
}

export class UpdateCurrentUserPassword {
  static readonly type = '[account] update user password';
  constructor(public password: UserPasswordModel) {}
}
